import type {
    JSX,
} from "preact";
import {
    forwardRef,
} from "preact/compat";

type SelectProps = JSX.SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({
        className = "",
        disabled,
        ...props
    }, ref) => {
        return (
            <select
                ref={ref}
                disabled={disabled}
                className={`
                    w-full px-3 py-2 rounded-lg
                    bg-bg-tertiary border border-border
                    text-text-primary text-sm
                    focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent
                    disabled:opacity-50 disabled:cursor-not-allowed
                    appearance-none cursor-pointer
                    bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23888888%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22%2F%3E%3C%2Fsvg%3E')]
                    bg-[length:20px] bg-[right_8px_center] bg-no-repeat pr-10
                    ${className}
                `.trim().replace(/\s+/g, " ")}
                {...props}
            />
        );
    },
);
